export default __webpack_public_path__ + "static/media/gallery-27.a4e32088.jpg";